export const getUserRole = (user) => {
  const membership = user && user.memberships && user.memberships.find(m => m.appId === 'dha' && m.spaceId);
  return membership && membership.role;
};

export const getAppRole = (user) => {
  const membership = user && user.memberships && user.memberships.find(m => m.appId === 'dha' && !m.spaceId);
  return membership && membership.role;
};



// WEBPACK FOOTER //
// ./src/utils/authorize.js